<div class="main-login-body" [ngStyle]="loginBodyStyle$ | async">
  <div class="login-align-wrap">
    <div class="trueview-logo">
      <h6 class="trueview-logo__title">TrueView</h6>
      @if (footerLogoStyle$ | async; as styles) {
        <i class="header-custom-logo" [ngStyle]="styles"></i>
        @if (showTrueViewSubtitle) {
          <span class="trueview-logo__subtitle">TrueView</span>
        }
      } @else {
        <i class="trueview-logo__img"></i>
        <span class="trueview-logo__subtitle">TrueView</span>
      }
      @if (translationLoadedForTheFirstTime()) {
        @if (appVersion) {
          <span class="trueview-logo__version">
            {{ (isClientLabeling() ? LABELS.clientVersion : LABELS.version) | translate }}
            {{ appVersion }}
          </span>
        }
      }
    </div>
    <div class="router-outlet">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div class="main-login-footer">
  <div class="login-footer-inner">
    <div class="footer-about">
      @if (!isClient()) {
        <app-about-true-view></app-about-true-view>
      }
    </div>
    @if (footerLogoStyle$ | async; as footerLogoStyle) {
      <i class="footer-custom-logo" [ngStyle]="footerLogoStyle"></i>
    }
    @if (isShowSelectSystemLanguage()) {
      <tvl-system-languages-selector class="footer-languages">
      </tvl-system-languages-selector>
    }
  </div>
</div>

<div custom-css></div>
